import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
   return (
      <footer className="bg-background pt-16 pb-8 border-t border-border">
         <div className="max-w-screen-xl mx-auto px-6 sm:px-16 lg:px-24">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16">
               {/* Column 1 - Brand */}
               {/* <div className="flex flex-col gap-6">
                  <Link to="/" className="flex items-center gap-2">
                     <img src="/logo.png" alt="Lenzura" className="h-12 w-auto" />
                  </Link>
                  <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
                     Find the lens that tells your story.
                  </p>
               </div> */}

               {/* Column 2 - Browse */}
               <div className="flex flex-col gap-4">
                  <h3 className="text-foreground font-semibold text-lg">Browse</h3>
                  <div className="flex flex-col gap-3">
                     <Link to="/how-it-works" className="text-muted-foreground hover:text-foreground transition-colors text-sm">How it works</Link>
                     <Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors text-sm">About</Link>
                     <Link to="/gigs" className="text-muted-foreground hover:text-foreground transition-colors text-sm">Browse Services</Link>
                  </div>
               </div>

               {/* Column 3 - Company */}
               <div className="flex flex-col gap-4">
                  <h3 className="text-foreground font-semibold text-lg">Company</h3>
                  <div className="flex flex-col gap-3">
                     <Link to="/about" className="text-muted-foreground hover:text-foreground transition-colors text-sm">About</Link>
                     <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors text-sm">Terms</Link>
                  </div>
               </div>

               {/* Column 4 - Support */}
               <div className="flex flex-col gap-4">
                  <h3 className="text-foreground font-semibold text-lg">Support</h3>
                  <div className="flex flex-col gap-3">
                     <Link to="/help" className="text-muted-foreground hover:text-foreground transition-colors text-sm">Help</Link>
                     <Link to="/contact" className="text-muted-foreground hover:text-foreground transition-colors text-sm">Contact</Link>
                     <Link to="/privacy" className="text-muted-foreground hover:text-foreground transition-colors text-sm">Privacy</Link>
                     <Link to="/terms" className="text-muted-foreground hover:text-foreground transition-colors text-sm">Terms</Link>
                  </div>
               </div>
            </div>

            {/* Bottom Bar */}
            <div className="pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-6">
               <p className="text-muted-foreground text-sm order-2 md:order-1">
                  © {new Date().getFullYear()} Lenzura. All rights reserved.
               </p>
               <div className="flex items-center gap-6 order-1 md:order-2">
                  <a href="#" className="text-muted-foreground hover:text-foreground transition-colors" aria-label="Twitter">
                     <Twitter className="h-5 w-5" />
                  </a>
                  <a href="#" className="text-muted-foreground hover:text-foreground transition-colors" aria-label="Instagram">
                     <Instagram className="h-5 w-5" />
                  </a>
                  <a href="#" className="text-muted-foreground hover:text-foreground transition-colors" aria-label="Facebook">
                     <Facebook className="h-5 w-5" />
                  </a>
               </div>
            </div>
         </div>
      </footer>
   );
};

export default Footer;